module.exports = "pegasus/assets/themelp1/travel/111.png";